export enum CompaniesEnum {
  Itechart = 'itechart',
  Vention = 'vention',
}
